import { helper } from '@ember/component/helper';
export const lowercase = ([text]) => {
  return text.toLowerCase();
};
export default helper(lowercase);